import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import SearchTextInput from '../../shared/components/formComponents/inputs/SearchTextInput';

class SearchFormV2 extends PureComponent {
    static propTypes = {
        updateAlgoliaSearchQuery: PropTypes.func,
        algoliaSearch: PropTypes.object,
        postAlgoliaSearch: PropTypes.func,
        algoliaIndex: PropTypes.string,
        clearAlgoliaSearchResult: PropTypes.func,
        placeholder: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            searchQuery: ''
        };
    }

    _handleOnClear = () => {
        const { updateAlgoliaSearchQuery, algoliaSearch, postAlgoliaSearch, algoliaIndex, clearAlgoliaSearchResult } =
            this.props;

        updateAlgoliaSearchQuery('');

        this.setState({
            searchQuery: ''
        });

        if (!isEmpty(algoliaSearch.filters)) {
            return postAlgoliaSearch('', algoliaIndex);
        }
        return clearAlgoliaSearchResult();
    };

    _handleOnChange = (e) => {
        this.setState({
            searchQuery: e.target.value
        });
    };

    _handleOnSubmit = (e) => {
        const { postAlgoliaSearch, algoliaIndex } = this.props;
        e.preventDefault();
        return postAlgoliaSearch(this.state.searchQuery, algoliaIndex);
    };

    render() {
        return (
            <form onSubmit={this._handleOnSubmit}>
                <SearchTextInput
                    onClear={this._handleOnClear}
                    onChange={this._handleOnChange}
                    value={this.state.searchQuery}
                    placeholder={this.props.placeholder || 'Search...'}
                />
            </form>
        );
    }
}

export default SearchFormV2;
